<template>
  <div class="class_report">
    <ClassHomeHead
      :classList="getClassListArr"
      :show="3"
    ></ClassHomeHead>
     <!-- @createFn="createFn" -->
    <!-- nav -->
    <nav>
      <MyNav :list="navArr"></MyNav>
    </nav>
     <div class="bgcf2">
      <MyBreadCrumb></MyBreadCrumb>
    </div>
    <div class="bgcf2 router_view pb50">
         <TchRouterContent></TchRouterContent>
      <!-- <router-view></router-view> -->
    </div>
  </div>
</template>

<script>
import { ClassList} from "@/api/projectAdministrator";
import TchRouterContent from "../tchClassHome/children/TchRouterContent";
export default {
  data() {
    return {
      navArr: [
        {
          name: "个人中心首页",
          path: "/ProjectMngStaff",
        },
        {
          name: "学员报告",
          path: "/StudentReport",
        },
        {
          name: "专家报告",
          path: "/ExpertReport",
        },
        {
          name: "基地校报告",
          path: "/baseschoolreport",
        },
        {
          name: "后勤报告",
          path: "/LogisticsReport",
        },
        {
          name: "班主任报告",
          path: "/TeacherReport",
        },
        {
          name: "考勤报告",
          path: "/CheckWorkReport",
        },
        {
          name: "学习成果报告",
          path: "/StudyAchievementReport",
        },
        {
          name: "培训效果报告",
          path: "/TrainEffectReport",
        },
        {
          name: "项目报告",
          path: "/ProjectReport",
        },
        {
          name: "班级材料",
          path: "/ClassMaterialsTidy",
        },
      ],
      getClassListArr:[]
    }
  },
   components: {
    TchRouterContent,
  },
  created() {
    // 班级列表
    ClassList({
      user_id: this.userInfo.id
    }).then((res) => {
      this.getClassListArr = res.data;
      // 处理时间
      this.getClassListArr.map((item) => {
        let arr1 = item.start_date.split(" ");
        let arr2 = item.start_date.split(" ");
        this.$set(item, "start_date", arr1[0]);
        this.$set(item, "end_date", arr2[0]);
      });
    });
  },
}
</script>
 
<style lang = "less" scoped>
.class_report {
  /* padding: 0 24px; */
  /* margin: 0 24px;     */
  nav {
    /* padding: 0 24px; */
    display: flex;
    justify-content: center;
  }
  .router_view {
    /* padding: 24px 0 30px; */
  }
}
</style>